import { io, Socket } from "socket.io-client";
// import type { PlotArtifactsReadyPayload } from "@shared/ws";
import { getAccessToken } from "@/lib/queryClient";

import { getWebSocketUrl } from "@/lib/urls";

// Prefer backend server (Express) for websockets; allow override via env
const inferBackendUrl = (): string => {
    return getWebSocketUrl();
};

const URL = inferBackendUrl();

// Create socket with explicit connect after token to avoid auth race during handshake
export const socket: Socket = (() => {
    const s = io(URL, {
        path: "/socket.io/",
        transports: ["websocket", "polling"],
        withCredentials: true,
        autoConnect: false,
    } as any);
    (async () => {
        try {
            const token = await getAccessToken();
            if (token) (s as any).auth = { token };
        } catch {}
        try { s.connect(); } catch {}
    })();
    return s;
})();

socket.on("connect", () => console.log("[ws] connected id=", socket.id));
socket.on("connect_error", (e) => console.error("[ws] connect_error", e?.message || e));
socket.on("disconnect", (r) => console.warn("[ws] disconnect", r));

// High-signal debug for one run
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const isProd = String((import.meta as any)?.env?.MODE || '').toLowerCase() === 'production';
if (!isProd && !(window as any).__sockTap) {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	(window as any).__sockTap = true;
	socket.onAny((event: string, payload: any) => {
		try {
			const keys = payload && typeof payload === "object" ? Object.keys(payload) : [];
			console.log("[ws:tap] event=", event, "keys=", keys);
		} catch {
			console.log("[ws:tap] event=", event, "(uninspectable)");
		}
	});
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
(window as any).__sock = socket;

// Project subscription helpers with acks
export async function subscribeProject(projectId: string, draftId?: string): Promise<'ok' | 'forbidden'> {
    if (!projectId) return 'forbidden';
    return await new Promise((resolve) => {
        try {
            socket.emit('subscribe_project', { projectId, ...(draftId ? { draftId } : {}) }, (resp: any) => {
                const ok = resp && (resp.ok === true);
            if (!isProd) console.log('[ws] subscribe_project ack', { projectId, draftId, ok });
                resolve(ok ? 'ok' : 'forbidden');
            });
        } catch {
            resolve('forbidden');
        }
    });
}

export async function unsubscribeProject(projectId: string, draftId?: string): Promise<'ok'> {
    if (!projectId) return 'ok';
    return await new Promise((resolve) => {
        try {
            socket.emit('unsubscribe_project', { projectId, ...(draftId ? { draftId } : {}) }, (_resp: any) => {
                if (!isProd) console.log('[ws] unsubscribe_project ack', { projectId, draftId });
                resolve('ok');
            });
        } catch {
            resolve('ok');
        }
    });
}

// Simple subscription flag helper for gating listeners externally
export function createSubscriptionGate() {
    let subscribed = false;
    return {
        markSubscribed: () => { subscribed = true; },
        markUnsubscribed: () => { subscribed = false; },
        isSubscribed: () => subscribed,
    } as const;
}


